'use strict';
var parent = require('../../stable/array/includes');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/actual/array/includes.js
// module id = 330
// module chunks = 0